import { FC, MouseEvent } from 'react'
import { noop } from 'lodash-es'
import Form from '@components/forms/form'
import CheckBox from '@components/forms/CheckBox'
import StateIndicator from '@components/StateIndicator'

type ChevronCheckBoxProps = {
  checked: boolean
  indeterminate: boolean
  onChange: (checked: boolean) => void
  onClickChevron: () => void
  isOpen?: boolean
}

const ChevronCheckBox: FC<ChevronCheckBoxProps> = ({
  checked = false,
  indeterminate = false,
  isOpen = false,
  onChange = noop,
  onClickChevron = noop,
}) => {
  const handleChevronClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClickChevron()
  }

  return (
    <Form
      className="control-small control-small--select-all-form control-small--select-all-form--with-chevron"
      ignoreMissingSubmitHandler={true}
    >
      <div className="checkbox-chevron-container">
        <div className="checkbox-container">
          <CheckBox onChange={onChange} checked={checked} indeterminate={indeterminate} />
        </div>
        <div className="chevron-container">
          <a className="chevron" onClick={handleChevronClick}>
            <StateIndicator isOpen={isOpen} />
          </a>
        </div>
      </div>
    </Form>
  )
}

export default ChevronCheckBox
